export default "__VITE_ASSET__32214866__"